export default "__VITE_ASSET__YONILrH0__"